module.exports = __webpack_public_path__ + "static/img/4b5375d77019d8aa76707d1357001987.913dccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4b5375d77019d8aa76707d1357001987.jpg
// module id = NnXw
// module chunks = 1